export const RepairRoutes = [
  {
    path:'/repair',
    name:'RepairPackage',
    component: () => import('@pages/repair/index.vue'),
  },
]

